import Cookies from 'js-cookie';

export async function getUsers() {
    const b4726486 = Cookies.get('b4726486');
    const dataToSend = { 'b4726486': b4726486 };
    const response = await fetch("https://arbitragem.bet:3131/administration/get_list_all_users/", {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(dataToSend)
    });

    if (response.ok) {
        const data = await response.json();
        return data;
    } else {
        window.location.href = "/";
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}


export async function updateUserData(dataToSend) {
    const b4726486 = Cookies.get('b4726486');
    dataToSend['b4726486'] = b4726486;
    const response = await fetch("https://arbitragem.bet:3131/administration/update_data_user/", {
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(dataToSend)
    });


    const data = await response.json();
    data["statusHttp"] = response.status;
    

    if (response.ok) {
        return data;
    }
    else if (data['message'] !== undefined) {                
        return data;
    }
    else {
        window.location.href = "/";
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}

export async function deepUpdateUserData(dataToSend) {
    const b4726486 = Cookies.get('b4726486');
    dataToSend['b4726486'] = b4726486;
    console.log("dataToSend", dataToSend);
    const response = await fetch("https://arbitragem.bet:3131/administration/deep_update_data_user/", {
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(dataToSend)
    });

    const data = await response.json();
    data["statusHttp"] = response.status;
    

    if (response.ok) {
        return data;
    }
    else if (data['message'] !== undefined) {                
        return data;
    }
    else {
        window.location.href = "/";
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}

export async function deleteUser(dataToSend) {
    const b4726486 = Cookies.get('b4726486');
    dataToSend['b4726486'] = b4726486;
    const response = await fetch("https://arbitragem.bet:3131/administration/delete_user/", {
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(dataToSend)
    });

    const data = await response.json();
    data["statusHttp"] = response.status;
    

    if (response.ok) {
        return data;
    }
    else if (data['message'] !== undefined) {                
        return data;
    }
    else {
        window.location.href = "/";
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}

export async function getPlans() {
    const b4726486 = Cookies.get('b4726486');
    const dataToSend = { 'b4726486': b4726486 };
    const response = await fetch("https://arbitragem.bet:3131/administration/get_list_all_plans/", {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(dataToSend)
    });

    if (response.ok) {
        const data = await response.json();
        return data;
    } else {
        window.location.href = "/";
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}

export async function getSpecificUser(dataToSend, setPageSession) {
    const b4726486 = Cookies.get('b4726486');
    dataToSend['b4726486'] = b4726486;
    const response = await fetch("https://arbitragem.bet:3131/administration/get_specific_user/", {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(dataToSend)
    });

    if (response.status === 404) {
        const data = await response.json();
        data["statusHttp"] = response.status;
        return data;
    }      

    else if (response.ok) {
        const data = await response.json();
        data["statusHttp"] = response.status;
        return data;
    } else {
        
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}